import React from 'react';
import { Form, Alert } from 'react-bootstrap';
import { SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
const ConsultantResponseForm = _ref => {
  let {
    consultantResponse,
    setConsultantResponse,
    onRespond,
    loading
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "pt-3 border-top"
  }, /*#__PURE__*/React.createElement(Alert, {
    variant: "danger",
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("strong", null, "Action Required:"), " The reviewer has requested clarification."), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Label, {
    className: "small"
  }, /*#__PURE__*/React.createElement("strong", null, "Your Response")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    rows: 3,
    value: consultantResponse,
    onChange: e => setConsultantResponse(e.target.value),
    placeholder: "Enter your response..."
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 justify-content-end"
  }, /*#__PURE__*/React.createElement(SaveButton, {
    size: "sm",
    onClick: onRespond,
    disabled: loading || !consultantResponse.trim(),
    text: "Respond",
    variant: "primary"
  })));
};
export default ConsultantResponseForm;